import styles from './Collectivite.styles'
import { Pressable, Text, View } from 'react-native';
import Base64Image from '../../components/Base64Image/Base64Image';
import { useState } from 'react';
import { useSessionStore } from '../../lib/Store/sessionStore.component';
import { CollectiviteItemProps } from './Collectivite.types';
import { useResponsive } from '@hooks';

export default function CollectiviteItem({index, database, navigation}: CollectiviteItemProps) {
  const { selectDatabase } = useSessionStore();
  const isResponsive = useResponsive();
  const [isPressed, setIsPressed] = useState(false);
  
  return (
    <View style={styles.listContent} key={`${database.tenant?.identifiant}_${database.component?.identifiant}`}>
      <Pressable
        onPress={() => selectDatabase(database, navigation)}
        onPressIn={() => setIsPressed(true)}
        onPressOut={() => setIsPressed(false)}
        style={[
          styles.pressableItem,
          isResponsive && styles.pressableItemResponsive,
          isPressed && styles.pressableItemActive
        ]}
        testID={`BT_BASE_${index + 1}`}
      >
        <View style={styles.descriptif}>
          <Text style={styles.tenantName}>
            {database.libelleDomaine || database.tenant?.nom || 'Nom non disponible'}
          </Text>
          <Text style={styles.componentName}>
            {database.component?.nom || database.component?.identifiant || 'Composant non disponible'}
          </Text>
        </View>
        {(database.fichesAgent?.length === 1) && database.fichesAgent[0].collectivites?.length === 1 && database.fichesAgent[0].collectivites[0].logo && (
          <View style={styles.logo}>
            <Base64Image base64={database.fichesAgent[0].collectivites[0].logo}/>
          </View>
        )}
      </Pressable>
    </View>
  );
};